import React from "react";
import { Check, UserRound } from "lucide-react";

// 拍摄前的纯视觉引导：根据 side 展示证件正面或背面示意，不访问摄像头。
export function DocumentGuideAnimation({ side = "front" }) {
  const isBack = side === "back";

  return (
    <div
      className={`document-guide-animation document-guide-animation-${side}`}
      aria-hidden="true"
    >
      <div className="document-guide-frame">
        <span className="document-guide-corner document-guide-corner-tl" />
        <span className="document-guide-corner document-guide-corner-tr" />
        <span className="document-guide-corner document-guide-corner-br" />
        <span className="document-guide-corner document-guide-corner-bl" />

        <div
          className={`document-guide-card ${
            isBack ? "document-guide-card-back" : "document-guide-card-front"
          }`}
        >
          {isBack ? (
            <>
              <span className="document-guide-magnetic-strip" />
              <span className="document-guide-signature-strip" />
              <span className="document-guide-barcode" />
            </>
          ) : (
            <>
              <span className="document-guide-photo">
                <UserRound className="size-6" strokeWidth={1.4} />
              </span>
              <span className="document-guide-details">
                <span className="document-guide-detail document-guide-detail-long" />
                <span className="document-guide-detail document-guide-detail-medium" />
                <span className="document-guide-detail document-guide-detail-short" />
              </span>
            </>
          )}
        </div>

        <span className="document-guide-scan-line" />
        <span className="document-guide-success">
          <Check className="size-5" strokeWidth={2.8} />
        </span>
      </div>
    </div>
  );
}
